import { useEffect } from 'react';
import { fcmManager } from '../notification/fcm.manager';
import { FcmContext, FcmMessageHandler } from '../notification/fcm.types';
import { useUserContextHook } from '../../useUserContextHook';


export const useFirebaseNotifications = (
    context?: FcmContext,
    onMessage?: FcmMessageHandler
) => {
    const { notificationToken } = useUserContextHook();

    useEffect(() => {
        let active = true;

        if (!notificationToken) {
            active = false;
            fcmManager.stop();
        }

        const init = async () => {
            await fcmManager.init(context);
            if (onMessage && active) {
                fcmManager.listen(onMessage);
            }
        };

        init();

        return () => {
            active = false;
            fcmManager.stop();
        };
    }, [context?.userId, notificationToken]);
};
